import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import React, { useEffect, useRef } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useNavigate } from "react-router-dom";

import { BsFileEarmarkExcelFill } from "react-icons/bs";
import { toast } from "react-toastify";

import { Colors } from "../../assets/Colors";
import Spinner from "../spinner/Spinner";
import Skeltons from "../loading/Skeltons";

export default function TablePayroll(props) {
  const tableRef = useRef(null);
  const navigate = useNavigate();

  const [isSuccess, setisSuccess] = React.useState(false);

  useEffect(() => {
    if (isSuccess) {
      toast.success("Success!", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        theme: "light",
      });
      setisSuccess(false);
    }
  });

  let data = props.tableData;
  if (props.usingMutation && !props.mutation.isLoading && data) {
    data = data.data;
  }

  return (
    <Card className="flex flex-col items-center content-center">
      <>
        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row"></div>
        {props.fetching ? (
          <div className="flex items-center">
            <Spinner />
          </div>
        ) : (
          <CardBody className="w-full pt-0 ">
            <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
              <div className="flex flex-row">
                <DownloadTableExcel
                  filename={"Report_" + props.title + "xlsx"}
                  sheet="users"
                  currentTableRef={tableRef.current}
                >
                  <button className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow">
                    {" "}
                    Download Excel
                  </button>
                </DownloadTableExcel>
              </div>
            </div>
            <div className="overflow-x-auto relative ">
              <table
                className="table-auto w-full bg-transparent border border-collapse text-sm"
                ref={tableRef}
              >
                <thead>
                  <tr>
                    <th
                      colSpan={"5"}
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    ></th>
                    <th
                      colSpan={"4"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Tunjangan
                    </th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    ></th>
                    <th
                      colSpan={"2"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Tunjangan
                    </th>
                    <th
                      colSpan={"2"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Extra Makan Lembur
                    </th>
                    <th
                      colSpan={"4"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Lembur
                    </th>
                    <th
                      colSpan={"2"}
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    ></th>
                    <th
                      colSpan={"4"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Potongan
                    </th>
                    <th
                      colSpan={"3"}
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    ></th>
                  </tr>
                  <tr>
                    <th
                      // rowSpan={}
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Nama Karyawan
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jabatan
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      NPWP
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      NIK
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Upah Pokok
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jabatan
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Keahlian
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Transport
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Makan
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Upah Pokok & Tunjangan
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Hari Kerja
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Total
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Hari Lembur
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Total
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jam Actual
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jam Lembur
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Rp / Jam
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jumlah
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jumlah Upah dan Lembur
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Kekurangan Gaji bln Lalu
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Mangkir
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Kelebihan
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      BPJS TK
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      BPJS KS
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Gaji Bersih
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      #
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {props.usingMutation && props.mutation.isLoading ? (
                    <Skeltons />
                  ) : (
                    <>
                      {Array.isArray(data) ? (
                        data.map((keyName, i) => {
                          var BPJSTK = 0.0;
                          var BPJSKS = 0.0;
                          var TotalLembur = 0.0
                          var RpperJam = 0.0

                          if (keyName["BPJSTKParam"]) {
                            if (keyName["BPJSTK"] == "") {
                              if (keyName["NamaTipeKaryawan"] == "Lepas/PHL") {
                                BPJSTK = Math.floor(
                                  (keyName["UpahPokokPHL"] * 25 * 2) / 100
                                );
                              } else {
                                BPJSTK = Math.floor(
                                  (keyName["UpahPokok"] * 3) / 100
                                );
                              }
                            } else {
                              BPJSTK = keyName["BPJSTK"];
                            }
                          }
                          if (keyName["BPJSKSParam"]) {
                            if (keyName["BPJSKS"] == "") {
                              if (keyName["NamaTipeKaryawan"] == "Lepas/PHL") {
                                BPJSKS = Math.floor(
                                  (keyName["UpahPokokPHL"] * 25 * 1) / 100
                                );
                              } else {
                                BPJSKS = Math.floor(
                                  (keyName["UpahPokok"] * 1) / 100
                                );
                              }
                            } else {
                              BPJSKS = keyName["BPJSKS"];
                            }
                          }
                          if (keyName["NamaTipeKaryawan"] == "Lepas/PHL") {
                            RpperJam = Math.floor(keyName["UpahPokokPHL"] * 25 / 173)
                            TotalLembur = 
                            keyName["UpahPokok"] +
                                keyName["JamLembur"] *
                                  (RpperJam)
                            
                          } else {
                            RpperJam = Math.floor(keyName["UpahPokok"] / 173)
                            TotalLembur = 
                              keyName["UpahPokok"] +
                                keyName["JamLembur"] *
                                  (RpperJam)
                            
                          }

                          return (
                            <tr key={keyName + i}>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["NamaKaryawan"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["Bagian"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["NPWP"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["NIK"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["UpahPokok"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["TJabatan"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["Keahlian"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["TTransport"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["TLemburMakan"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {parseFloat(
                                  keyName["UpahPokok"]
                                ).toLocaleString("in-ID", {
                                  maximumFractionDigits: 2,
                                })}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["HariKerja"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {parseFloat(
                                  keyName["HariKerja"] * keyName["THarian"]
                                ).toLocaleString("in-ID", {
                                  maximumFractionDigits: 2,
                                })}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["HariLemburMakan"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {parseFloat(
                                  keyName["HariLemburMakan"] *
                                    keyName["TLemburMakan"]
                                ).toLocaleString("in-ID", {
                                  maximumFractionDigits: 2,
                                })}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["JamActual"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["JamLembur"]}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {parseFloat(RpperJam).toLocaleString("in-ID", {
                                  maximumFractionDigits: 2,
                                })}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {/* TotalLembur */}
                                {parseFloat(
                                  Math.floor(TotalLembur)
                                ).toLocaleString("in-ID", {
                                  maximumFractionDigits: 2,
                                })}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {/* Total Upah dan Lembur */}
                                {parseFloat(
                                  Math.floor(
                                    TotalLembur +
                                      keyName["HariLemburMakan"] *
                                        keyName["TLemburMakan"] +
                                      keyName["HariKerja"] * keyName["THarian"]
                                  )
                                ).toLocaleString("in-ID", {
                                  maximumFractionDigits: 2,
                                })}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {0}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {0}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {0}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {/* BPJSTK */}

                                {BPJSTK}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {/* BPJSKS */}

                                {BPJSKS}
                              </th>
                              <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                {keyName["GajiBersih"] == ""
                                  ? parseFloat(
                                      Math.ceil(
                                        (Math.floor(TotalLembur) -
                                          BPJSTK -
                                          BPJSKS +
                                          keyName["HariLemburMakan"] *
                                            parseFloat(
                                              keyName["TLemburMakan"]
                                            ) +
                                          keyName["HariKerja"] *
                                            parseFloat(keyName["THarian"])) /
                                          1000
                                      ) * 1000
                                    ).toLocaleString("in-ID", {
                                      maximumFractionDigits: 2,
                                    })
                                  : (
                                      Math.round(
                                        parseFloat(keyName["GajiBersih"]) / 1000
                                      ) * 1000
                                    ).toLocaleString("in-ID", {
                                      maximumFractionDigits: 2,
                                    })}
                              </th>
                              <th
                                className={
                                  "py-4 px-6 font-medium whitespace-nowrap border"
                                }
                              >
                                <a
                                  onClick={(e) =>
                                    navigate(
                                      "/payroll/slip/" +
                                        props.param.Bulan +
                                        props.param.Tahun +
                                        "/" +
                                        keyName["NIK"]
                                    )
                                  }
                                  className={
                                    "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                                  }
                                >
                                  Slip
                                </a>
                              </th>
                            </tr>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        )}
        {!props.usingMutation && !props.tableData && !props.fetching && (
          <div className="w-full flex flex-col justify-center items-center">
            <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400" />
            <div className="pb-4 text-gray-800">No Data</div>
          </div>
        )}
      </>
    </Card>
  );
}
